import { FC } from 'react'

type Props = {
  state: string
  setState: React.Dispatch<React.SetStateAction<string>>
  placeholder: string
}

const SearchBox: FC<Props> = (props) => {
  const { state, setState, placeholder } = props

  return (
    <span>
      <input
        type="search"
        className="w-100 searchBox"
        placeholder={placeholder}
        value={state}
        onChange={(e) => setState(e.target.value)}
      />
    </span>
  )
}

export default SearchBox
